"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AuthProvider_1 = require("../AuthProvider");
const hookrouter_1 = require("hookrouter");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const ElevatedView_1 = __importDefault(require("../ElevatedView"));
const LoginPage = () => {
    const auth = AuthProvider_1.useAuth();
    react_1.useEffect(() => {
        if (auth.isAuthenticated) {
            hookrouter_1.navigate('/', true);
        }
    }, [auth.isAuthenticated]);
    return react_1.default.createElement(office_ui_fabric_react_1.Stack, { verticalAlign: "center", horizontalAlign: "center", verticalFill: true },
        react_1.default.createElement(ElevatedView_1.default, { depth: 16, style: { padding: 55, width: '400px', maxWidth: '90%', textAlign: 'center' } },
            react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "xxLarge" }, "Welcome"),
            react_1.default.createElement("p", null, "To continue please login below."),
            react_1.default.createElement(office_ui_fabric_react_1.Separator, null),
            react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { styles: { root: { marginTop: 20 } }, iconProps: { iconName: 'OfficeLogo' }, onClick: () => auth.login() }, "Log in with Work Email")));
};
exports.default = LoginPage;
